module.exports = __webpack_public_path__ + "static/media/phone-office.04ddc58d.svg";